export default {
	path: '/eduHome',
	name: 'eduHome',
	component: () => import('@/views/edu/eduHome'),
	children: [{
			path: 'projectList',
			component: () => import('@/views/edu/projectList'),
		},
		{
			path: 'projectAdd',
			component: () => import('@/views/edu/projectAdd'),
		},
		{
			path: 'projectDetail/:id',
			component: () => import('@/views/edu/projectDetail'),
		},
		{
			path: 'confirmList',
			component: () => import('@/views/edu/confirmList'),
		},
		{
			path: 'confirmAdd',
			component: () => import('@/views/edu/confirmAdd'),
		},
		{
			path: 'confirmDetail/:id',
			component: () => import('@/views/edu/confirmDetail'),
		},
	]
}